export default "__VITE_ASSET__BprJnSNb__"